import React from 'react'
import CopyText from '../../../components/shared/elements/CopyText'
import { Unit } from '../../../store/slices/unitsSlice'

export default function VerifiedUnitInformation({ currentUnit }: { currentUnit: Unit }) {

    return (
        <>
            <div className="my-2 min-w-125px py-3 px-4 w-100 mb-4 row g-0 d-flex flex-row">
                <div className="col-9 fs-5 g-0 d-flex flex-column justify-content-center">
                    <div className="">
                        <div className="mb-2 fs-4 fw-bold counted">
                            Publish end date :
                        </div>
                        <div className="mb-2 fs-4 fw-bold counted">
                            Area :
                        </div>
                    </div>
                </div>
                <div className="col-3 g-0 d-flex flex-column align-items-end ">

                    <div className='mb-2 fs-4 fw-semi-bold counted'>
                        <CopyText text={new Date(currentUnit?.attributes?.PublishEndDate ?? "").toDateString()} />
                    </div>

                    <div className='mb-2 fs-4 fw-semi-bold counted  text-end'>
                        <CopyText text={currentUnit?.attributes?.Property?.data.attributes.Area ?? ""} />
                    </div>
                </div>
            </div>

        </>

    )
}
